import { createContext, type ReactNode, useContext } from 'react';

import { useSidebarState } from '@/hooks/use-sidebar-state';

type SidebarContextValue = ReturnType<typeof useSidebarState>;

const SidebarContext = createContext<SidebarContextValue | null>(null);

export type SidebarProviderProps = {
  children: ReactNode;
};

export function SidebarProvider({ children }: SidebarProviderProps) {
  const sidebarState = useSidebarState();

  return (
    <SidebarContext.Provider value={sidebarState}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}
